import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { breakpoint, theme } from '../../../theme';
import { SubNavBottomDivider } from './SubNavBottomDivider';

export type SubNavigationProps = PropsWithChildren<{
  showDivider?: boolean;
}>;

const SubNavBase = styled.nav`
  overflow-x: auto;

  ${breakpoint('sm')`
    overflow-x: initial;
  `}
`;

const SubNavItemsContainer = styled.ul`
  display: flex;
  padding: 0 ${theme.spacings[1].rem};
  margin: 0;
  list-style: none;

  ${breakpoint('lg')`
    padding: ${theme.spacings[3].rem} 0;
  `};
`;

// Use Component inside Grid
export const SubNavigation: React.FC<SubNavigationProps> = ({
  children,
  showDivider = true,
}) => {
  return (
    <>
      <SubNavBase>
        <SubNavItemsContainer>{children}</SubNavItemsContainer>
      </SubNavBase>
      {showDivider && <SubNavBottomDivider />}
    </>
  );
};
